import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=72651137&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=72651137&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72651137",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72651137')) {
      api.createRecord('72651137', component.options)
    } else {
      api.reload('72651137', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=72651137&scoped=true&", function () {
      api.rerender('72651137', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Kpz1URqTuh3J/JS/comp/PopupDialog.vue"
export default component.exports